/* eslint-disable no-useless-catch */
import EvaluacionService from '@/services/Evaluacion'
import axios from '@/utils/axios'

const evaluacionApi = new EvaluacionService(axios)

const actions = {
  async iniciarEvaluacion (context: any, activityScheduleId: number) {
    context.commit('setCargando', true)
    try {
      const data = await evaluacionApi.iniciar(activityScheduleId)
      context.commit('setEvaluacionEnCurso', {
        reviewsAnswerId: data.reviewsAnswerId,
        preguntas: data.preguntas,
        tiempoDisponible: data.tiempoDisponible,
        dateCreation: data.dateCreation
      })
      return data
    } catch (error: any) {
      throw error
    } finally {
      context.commit('setCargando', false)
    }
  },

  async responderEvaluacion (context: any, payload: { reviewsAnswerId: number, respuestas: Array<{ questionId: number, answerId: number }> }) {
    context.commit('setCargando', true)
    try {
      const data = await evaluacionApi.responder(payload.reviewsAnswerId, payload.respuestas)
      context.commit('setResultado', data)
      return data
    } catch (error: any) {
      throw error
    } finally {
      context.commit('setCargando', false)
    }
  },

  async consultarResultado (context: any, reviewsAnswerId: number) {
    context.commit('setCargando', true)
    try {
      const data = await evaluacionApi.consultarResultado(reviewsAnswerId)
      context.commit('setResultado', data)
      return data
    } catch (error: any) {
      throw error
    } finally {
      context.commit('setCargando', false)
    }
  },

  async recuperarPreguntas (context: any, reviewsAnswerId: number) {
    context.commit('setCargando', true)
    try {
      const data = await evaluacionApi.obtenerPreguntas(reviewsAnswerId)
      context.commit('setEvaluacionEnCurso', {
        reviewsAnswerId: data.reviewsAnswerId,
        preguntas: data.preguntas,
        tiempoDisponible: data.tiempoDisponible,
        dateCreation: data.dateCreation
      })
      return data
    } catch (error: any) {
      throw error
    } finally {
      context.commit('setCargando', false)
    }
  },

  limpiarEvaluacion (context: any) {
    context.commit('limpiarEvaluacion')
  }
}

export default actions
